import React from 'react';
import { FaCheckCircle, FaTimesCircle, FaExclamationCircle } from 'react-icons/fa';

import Alert from './styles';

const AlertComponent = ({ options, message }) => (
  <Alert type={options.type}>
    {options.type === 'info' && <FaExclamationCircle className="fa fa-exclamation-circle" />}
    {options.type === 'success' && <FaCheckCircle className="fa fa-check-circle" />}
    {options.type === 'error' && <FaTimesCircle className="fa fa-times-circle" />}
    {message}
  </Alert>
);

export default AlertComponent;
